import Text from '../Text/Text';
import { Column, Row } from '../Grid/Grid';
import { LeftSpaced, Spaced } from '../Spaced/Spaced';
import Icon from '../Icon/Icon';
import Button from '../Button/Button';
import useStyles from './styles';

function SelectableItem({
  icon,
  title,
  subtitle,
  extra,
  onClick,
  disabled = false,
  ...props
}: SelectableItemProps) {
  const classes = useStyles();

  return (
    <Button type="panel" data-testid={props['data-testid']} onClick={onClick} disabled={disabled}>
      <Spaced>
        <Row justifyContent="space-between">
          <Column>
            <Row justifyContent="space-between">
              <Icon name={icon} className={disabled ? classes.disabled : ''} />
              <LeftSpaced>
                <Column>
                  <Text type={disabled ? 'disabled' : 'normal'}>{title}</Text>
                  {subtitle && <Text>{subtitle}</Text>}
                  {extra && <Text type="small">{extra}</Text>}
                </Column>
              </LeftSpaced>
            </Row>
          </Column>
          <Icon name="angleRight" className={disabled ? classes.disabled : ''} />
        </Row>
      </Spaced>
    </Button>
  );
}

export default SelectableItem;
